/* eslint-disable @typescript-eslint/no-explicit-any */
export const mapConditionsOnUpdate = (conditions: Array<{type: string, relationship?: string, values: any}>) => {
	return conditions.map((condition: {type: string, relationship?: string, relationshipCheck?: string, values: any}) => {
		if (condition.type === 'field-meet-a-certain-criteria' || condition.type === 'field-meet-a-certain-criteria-with-multiple-values') {
			return {
				type: condition.type,
				relationship: condition.relationship,
				relationshipCheck: condition.relationshipCheck,
				data: condition.values,
			};
		}

		return {
			type: condition.type,
			data: condition.values,
		};
	});
};

export const mapActionsOnUpdate = (actions: Array<{type: string, values: any}>) => {
	return actions.map((action: {type: string, values: any}) => {
		if (action.type === 'edit-work-item') {
			return {
				type: action.type,
				data: {
					...action.values,
					relationship: action.values.relationship,
					fieldAction: action.values.action,
				},
			};
		}
		return {
			type: action.type,
			data: {
				...action.values,
				relationship: action.values.relationship,
			},
		};
	});
};
